<template>
  <el-dialog
    :visible.sync="vModel"
    v-bind="dialogProps"
    class="my-dialog"
    :top="top"
    @closed="$emit('closed')">
    <template
      #title>
      <slot
        name="title" />
    </template>
    <slot />
    <template
      slot="footer"
      v-if="!hideFooter">
      <slot
        name="footer">
        <el-button
          size="small"
          type="info"
          @click="$emit('cancel')">
          {{ cancelText }}
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="$emit('confirm')"
          :loading="loading">
          {{ confirmText }}
        </el-button>
      </slot>
    </template>
  </el-dialog>
</template>

<script>
import vModel from '@/utils/mixins/vModel'
import { Dialog } from 'element-ui'
import { useComponentProps } from '@/utils/use/props'
const useDialogProps = useComponentProps(
  Dialog,
  'dialogProps'
)
export default {
  data () {
    return {
      visi: true
    }
  },
  props: {
    ...Dialog.props,
    top: {
      type: String,
      default: '18vh'
    },
    width: {
      type: String,
      default: '95vw'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    loading: Boolean,
    hideFooter: Boolean
  },
  mixins: [vModel, useDialogProps]
}
</script>

<style lang="scss" scoped>
.my-dialog{
  >>> .el-dialog__header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    height: 3.4rem;
    background-color: $theme-color;
    margin: 0;
    .el-dialog__title{
      color: #fff;
      font-size: 1.25rem;
      border-radius: .2rem .2rem 0 0;
      line-height: initial;
    }
    .el-dialog__headerbtn{
      position: initial;
      padding: 0;
      width: 1.6rem;
      height: 1.6rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.6rem;
      i{
        color: #fff;
        transition: .15s ease-in-out;
      }
      &:hover{
        i{
          transform: scale(1.05);
        }
      }
    }
  }
  >>> .el-dialog__body{
    padding: 1rem 1rem .8rem .8rem;
  }
  >>> .el-dialog__footer{
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: .95rem;
    padding: .8rem 0;
    border-top: 1px solid #e6e6e6;
    .el-button{
      height: initial;
      box-sizing: content-box;
      &+.el-button{
        margin-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyDialog/index.vue